import React from "react";

const UserDocumentViewer = ({ adminDocuments }) => {
  if (!adminDocuments || adminDocuments.length === 0) return null;

  const base = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";

  return (
    <div className="mt-4 p-4 border rounded-xl bg-white shadow-sm">
      <h4 className="text-sm font-bold text-gray-800 mb-3">Additional Documents</h4>
      <div className="space-y-3">
        {adminDocuments.map((doc, idx) => (
          <div key={idx} className="p-3 bg-gray-50 border border-gray-100 rounded-lg flex flex-col gap-2">
            {doc.remark && (
              <p className="text-sm text-gray-700">
                <span className="font-semibold text-gray-900">Remark:</span> {doc.remark}
              </p>
            )}
            <div>
              <p className="text-xs text-gray-500 mb-1">Attached Files:</p>
              <div className="flex flex-wrap gap-2">
                {doc.files.map((file, fIdx) => {
                  const fileName = file.split("/").pop() || file.split("\\").pop();
                  return (
                    <a
                      key={fIdx}
                      href={`${base}/${file}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1.5 rounded hover:bg-indigo-200 transition-colors truncate max-w-[250px]"
                      title={fileName}
                    >
                      {fileName}
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserDocumentViewer;
